import { toast } from 'react-toastify';
import { withState, withProps, defaultProps } from 'recompose';
import { translate } from 'react-i18next';
import sh from './string.helper';
import getErrorMessage from '../components/validation/errorMessages';

const methodPrefix = 'set';

const getSetMethodName = (name) => {
  let parts = name.split('_');
  parts = parts.map(part => sh.firstLetterToUpperCase(part));
  return methodPrefix + parts.join('');
};

const getWithStateOptions = (name, defaultValue = '') => [name, getSetMethodName(name), defaultValue];

const onChange = props => event => props[getSetMethodName(event.target.name)](event.target.value);

/**
 * Update formData simple attribute
 * @param props
 */
const onChangeFormDataElement = props => ({ target }) => {
  let newValue;
  if (target.type === 'checkbox') {
    newValue = target.checked ? 1 : 0;
  } else {
    newValue = target.value;
  }
  return props.setFormData({
    ...props.formData,
    [target.name]: newValue,
  });
};

/**
 * Update formData group attribute
 * @param props
 */
const onChangeFormDataElementByGroup = props => group => ({ target }) => {
  let newValue;
  if (target.type === 'checkbox') {
    newValue = target.checked ? 1 : 0;
  } else {
    newValue = target.value;
  }
  return props.setFormData({
    ...props.formData,
    [group]: {
      ...props.formData[group],
      [target.name]: newValue,
    },
  });
};

/**
 * Update formData multilang attribute
 * @param props
 */
const onChangeFormDataMlElement = props => (lang, defaultLanguage) => ({ target }) => {
  if (lang === defaultLanguage) {
    props.setFormData({
      ...props.formData,
      [target.name]: target.value,
      ml: {
        ...props.formData.ml,
        [lang]: {
          ...props.formData.ml[lang],
          [target.name]: target.value,
        },
      },
    });
  } else {
    props.setFormData({
      ...props.formData,
      ml: {
        ...props.formData.ml,
        [lang]: {
          ...props.formData.ml[lang],
          [target.name]: target.value,
        },
      },
    });
  }
};

const notify = (t, text) => toast.success(text || t('Successfully saved!'));

const defaultRecompose = defaultFormData => ([
  translate('portal'),
  withState(...getWithStateOptions('errors', {})),
  withState(...getWithStateOptions('isNewModel', true)),
  withState(...getWithStateOptions('isLoading', true)),
  withState(...getWithStateOptions('isSubmitting', false)),
  withState(...getWithStateOptions('isSubmittingRedirect', false)),
  withState('formData', 'setFormData', defaultFormData),
]);

const titlePrefix = ' #';
const getTitleEnd = props => (props.match && props.match.params.id ? titlePrefix + props.match.params.id : '');

const beforeSave = async (event, props, redirect) => {
  event.persist();
  event.preventDefault();
  await props.setIsSubmittingRedirect(redirect);
  props.setIsSubmitting(true);
};

const initModelData = async (props, applyModel, ModelService, afterSetModel) => {
  if (props.match && props.match.params.id) {
    const model = await ModelService.get(props.match.params.id);
    await applyModel(props.setFormData, model);
    await props.setIsNewModel(false);
    if (typeof afterSetModel === 'function') {
      await afterSetModel(props, model);
    }
    props.setIsLoading(false);
    return model;
  }
  props.setIsLoading(false);
  return null;
};

const createApplyModel = defaultFormData => async (setFormData, model) => {
  await setFormData({
    ...defaultFormData,
    ...model,
  });
};

const defaultInputParams = [
  withProps((props) => {
    let { value, errors } = props;
    errors = errors || {};
    const { formData, id, t, name, onChange } = props;
    if (typeof value === 'undefined') {
      value = formData ? formData[name] : undefined;
    }
    value = value === null ? '' : value;
    return {
      name: name.split('.').pop(),
      valid: !errors[name],
      errorMessage: errors[name] ? getErrorMessage(
        t,
        errors[name].validation,
        errors[name].message,
      ) : '',
      value,
      id: id || name,
      onChange: name.split('.').pop() !== name ? onChange(name.split('.')[0]) : onChange,
    };
  }),
  defaultProps({
    errors: {},
    label: '',
    value: '',
    type: 'text',
  }),
];

const getCaretPosition = (html) => {
  let sel;
  let range;
  if (window.getSelection) {
    // IE9 and non-IE
    sel = window.getSelection();
    if (sel.getRangeAt && sel.rangeCount) {
      range = sel.getRangeAt(0);
      range.deleteContents();
      const el = document.createElement('div');
      el.innerHTML = html;
      const frag = document.createDocumentFragment();
      let node;
      let lastNode;
      while ((node = el.firstChild)) {
        lastNode = frag.appendChild(node);
      }
      range.insertNode(frag);
      if (lastNode) {
        range = range.cloneRange();
        range.setStartAfter(lastNode);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
      }
    }
  } else if (document.selection && document.selection.type !== 'Control') {
    // IE < 9
    document.selection.createRange().pasteHTML(html);
  }
};

export default {
  getWithStateOptions,
  wso: getWithStateOptions,
  getSetMethodName,
  smn: getSetMethodName,
  onChange,
  onChangeFormDataElement,
  onChangeFormDataMlElement,
  onChangeFormDataElementByGroup,
  notify,
  defaultRecompose,
  getTitleEnd,
  beforeSave,
  initModelData,
  createApplyModel,
  defaultInputParams,
  getCaretPosition,
};



// WEBPACK FOOTER //
// ./src/helpers/form.helper.js